export default __webpack_public_path__ + "static/media/image-keyboard.f344ffa9.jpg";